import {FunctionComponent, useMemo} from 'react';
import {format, parseISO} from 'date-fns';
import {useTranslation} from 'react-i18next';
import {useFormatFullName} from '@/hooks/use-format-fullname';
import {DocumentContact} from '@/interfaces/document';

type I18NStatusKey = 'created-at' | 'modified-at' | 'completed-at' | 'signed-at' | 'sent-at';

interface Props {
  i18nStatusKey: I18NStatusKey;
  date: string;
  contact?: DocumentContact | null;
}

export const DocumentStatusActionLabel: FunctionComponent<Props> = ({i18nStatusKey, date, contact, ...props}) => {
  const {t} = useTranslation('common', {
    keyPrefix: 'components.document-menu.document-list.item.content.signature-action',
  });
  const formatFullName = useFormatFullName();

  const formattedDate = format(parseISO(date), 'yyyy-MM-dd');
  const formattedName = useMemo(() => {
    if (!contact) return '';
    return formatFullName(contact?.firstName, contact?.lastName);
  }, [contact, formatFullName]);

  return (
    <div {...props} data-testid={`${i18nStatusKey}-label`}>
      {i18nStatusKey === 'signed-at' || !contact
        ? t(`${i18nStatusKey}.default`, {date: formattedDate})
        : t(`${i18nStatusKey}.with-name`, {date: formattedDate, name: formattedName})}
    </div>
  );
};
